import { useSelector } from 'react-redux'

import { isMutualAvailabilityEnabledSelector } from 'selectors/mutual_availability'

export const useMutualAvailabilityEnabled = () => useSelector((state) => isMutualAvailabilityEnabledSelector(state))
